import React, { useCallback } from 'react';
import classnames from 'classnames';
import { is } from 'ramda';
export var ButtonType;
(function (ButtonType) {
    ButtonType["PRIMARY"] = "PRIMARY";
    ButtonType["LINK"] = "LINK";
    ButtonType["SECONDARY"] = "SECONDARY";
})(ButtonType || (ButtonType = {}));
export const Button = ({ type = ButtonType.PRIMARY, disabled, onClick, children, className, ...rest }) => {
    const theme = type === ButtonType.PRIMARY ? '-main' : type.toLowerCase();
    const handleCLick = useCallback(() => {
        if (!disabled && is(Function, onClick)) {
            onClick();
        }
    }, [disabled, onClick]);
    return (<button type="button" className={classnames('button', `button-${theme}`, className)} disabled={disabled} onClick={handleCLick} {...rest}>
      {children}
    </button>);
};
